import React from 'react'
import { isCompleteStatus, isLockedStatus, getRequirementDisplayData } from './utils'
import { resolveUrlForArticles } from './utils/urlUtils'
import { REQUIREMENT, PAT_WARNING_MESSAGES } from './utils/constants/levels'
import { ADDITIONAL_REQUIREMENTS } from './utils/constants/additionalRequirements'
import RequirementActionLinks from './RequirementActionLinks'
import LockIconSvg from '../../../assets/icons/icon-lock-status.svg'
import {
  RequirementCardStyled,
  RequirementHeader,
  RequirementTitle,
  StatusBadgeSmall,
  StatusBadgeText,
  StatusBadgeCheckmark,
  StatusBadgeLock,
  RequirementDescription,
  RequirementInfoBanner,
  RequirementInfoText,
  TextButton
} from './Styles/ProgressTracker.styles'

const RequirementCard = ({ requirement, activeLevel, shouldShowPATWarning }) => {
  const baseDisplayData = getRequirementDisplayData(activeLevel, requirement)
  const isComplete = isCompleteStatus(requirement.status)
  const isLocked = isLockedStatus(requirement.status)
  const isPATWithWarning = requirement.key === REQUIREMENT.PLAYING_ABILITY_TEST && shouldShowPATWarning

  const displayData = isPATWithWarning && baseDisplayData
    ? {
        ...baseDisplayData,
        secondaryLinkText: ADDITIONAL_REQUIREMENTS.PAT.secondaryLinkText,
        secondaryLinkUrl: ADDITIONAL_REQUIREMENTS.PAT.secondaryLinkUrl
      }
    : baseDisplayData

  return (
    <RequirementCardStyled hasWarning={isPATWithWarning}>
      {isPATWithWarning && (
        <RequirementInfoBanner>
          <RequirementInfoText>
            {PAT_WARNING_MESSAGES.BANNER}{' '}
            {displayData?.infoLinkText && displayData?.infoLinkUrl && (
              <TextButton
                as="a"
                href={resolveUrlForArticles(displayData.infoLinkUrl)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {displayData.infoLinkText}
              </TextButton>
            )}
          </RequirementInfoText>
        </RequirementInfoBanner>
      )}
      <RequirementHeader>
        <RequirementTitle>{displayData?.name || requirement.name}</RequirementTitle>
        <StatusBadgeSmall backgroundColor={displayData?.backgroundColor}>
          {isComplete && <StatusBadgeCheckmark color={displayData?.color} />}
          {isLocked && <StatusBadgeLock src={LockIconSvg} alt="Locked" />}
          <StatusBadgeText textColor={displayData?.color}>
            {displayData?.label || requirement.status}
          </StatusBadgeText>
        </StatusBadgeSmall>
      </RequirementHeader>
      <RequirementDescription>
        {isPATWithWarning 
          ? PAT_WARNING_MESSAGES.DESCRIPTION
          : displayData?.message || ''
        }
        {!isPATWithWarning && displayData?.infoLinkText && displayData?.infoLinkUrl && (
          <>
            {' '}
            <TextButton
              as="a"
              href={resolveUrlForArticles(displayData.infoLinkUrl)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {displayData.infoLinkText}
            </TextButton>
          </>
        )}
      </RequirementDescription>
      <RequirementActionLinks
        displayData={displayData}
        requirementStatus={requirement.status}
        activeLevel={activeLevel}
        requirementKey={requirement.key}
      />
    </RequirementCardStyled>
  )
}

export default RequirementCard
